import { render, staticRenderFns } from "./EventHistoryAddParticipantDialog.vue?vue&type=template&id=3259dc63&"
import script from "./EventHistoryAddParticipantDialog.vue?vue&type=script&lang=js&"
export * from "./EventHistoryAddParticipantDialog.vue?vue&type=script&lang=js&"
import style0 from "./EventHistoryAddParticipantDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports